import { AdSpaceIcon } from 'assets/icons/AdSpaceIcon'
import { ImageIcon } from 'assets/icons/ImageIcon'
import { PlayIcon } from 'assets/icons/PlayIcon'
import { SelectIcon } from 'assets/icons/SelectIcon'

export const CREATIVE_TYPES_OPTIONS = [
  { value: '', label: 'All types' },
  { value: '0,10-Number-eq', label: 'Image' },
  { value: '1,11-Number-eq', label: 'Video' },
  { value: '2,3,4,5-Number-eq', label: 'Stream' },
]

export const CREATIVE_TYPE_BY_CREATIVE_VALUE = {
  '': 'All types',
  '0,10-Number-eq': 'Image',
  '1,11-Number-eq': 'Video',
  '2,3,4,5-Number-eq': 'Stream',
}

export const CREATIVE_ICON_BY_VALUE = {
  '': <SelectIcon />,
  '0,10-Number-eq': <ImageIcon />,
  '1,11-Number-eq': <PlayIcon />,
  '2,3,4,5-Number-eq': <AdSpaceIcon />,
}
